export default __webpack_public_path__ + "static/media/linkedin.e501b7ce.svg";